module.exports = __webpack_public_path__ + "img/Chris Sells.861ea831.jpg";